export default "__VITE_ASSET__A7_ixVnz__"